module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_67"
    }
  }, [_c('span', [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e747667"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c4_r1#d6e11",
      "id": "d7e11"
    }
  }, [_vm._v("6 "), _c('br'), _c('br'), _c('i', [_vm._v("Sehnsucht ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e748467"
    }
  }, [_c('span', [_c('i', [_vm._v("He who binds to himself a joy "), _c('br'), _vm._v(" \nDoes the winged life destroy; "), _c('br'), _vm._v(" \nBut he who kisses the joy as it flies "), _c('br'), _vm._v(" \nLives in eternity’s sunrise.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e749867"
    }
  }, [_c('span', [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAKE ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e750467"
    }
  }, [_c('span', [_vm._v("C. S. Lewis’s joy was intimately connected to his experience of poignant longing. This longing could be sparked simply by the idea of autumn or an encounter with a “squirrel and a fat old rat in Addison’s walk” just steps from his room at Magdalen College."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d150",
      "id": "a150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e752267"
    }
  }, [_c('span', [_vm._v("In his pilgrimage into Christianity, Lewis met Owen Barfield, who quickened this longing in an “idea of the spiritual world as home—the discovery of homeliness in that which is otherwise so remote—the feeling that you are coming back tho’ to a place you have never yet reached.” Barfield found such spiritual nostalgia in the writings of George MacDonald and G. K. Chesterton. He protested against the abuse of R. L. Stevenson’s romantic saying that “it is better to travel hopefully than to arrive.” It is nonsense to imagine traveling hopefully with no hope of arriving. “It’s like saying ‘What a bore. I see we shan’t be able to go to the opera after all. However we can still enjoy looking forward to going!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d151",
      "id": "a151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Picking up on this idea, Lewis explained that his tastes of joy were pointers, hints, and clues of what he truly sought.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e756767"
    }
  }, [_c('span', [_vm._v("For now, our joy is rough and unsteady. It cannot be held or kept. Any attempt to grasp it is to try to grasp Gerard Manley Hopkins’s dim and faint echo of beauty. It dies in our clutch, becoming like lead. But the golden echo, which gives beauty back to beauty’s maker and joy to the fount of joy, rings clear and true and eternal. It whispers in the wind, calling us to remember the word we first heard. The proverb reminds us, “Like cold water to a thirsty soul, so is good news from a far country” (Prov. 25:25 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("nrsv")]), _vm._v("). So the voice from our home country comes to us while we are aliens and sojourners in a strange land. The merry characters of Kenneth Grahame’s "), _c('i', [_vm._v("Wind in the Willows ")]), _vm._v("were, while separated from their homes, struck with sweet wantings—a deep longing for home, for the place each was designed to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_68"
    }
  }, [_c('span', [_vm._v("58")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e762468"
    }
  }, [_c('span', [_vm._v("In a letter to Dom Bede Griffiths (November 1959), Lewis expressed his feelings behind his desire for his real country:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e763468"
    }
  }, [_c('span', [_vm._v("About death I go through different moods, but the times when I can desire it are never, I think, those when this world seems harshest. On the contrary, it is just when there seems to be most of Heaven already here that I come nearest to longing for a patria. It is the bright frontispiece which whets one to read the story itself. All joy (as distinct from mere pleasure, still more amusement) emphasizes our pilgrim status; always reminds, beckons, awakens desire. Our best havings are wantings."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d152",
      "id": "a152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e766768"
    }
  }, [_c('span', [_vm._v("Lewis balanced the human pilgrimage on the razor edge between these two possible ways: “Apparently, then, our lifelong nostalgia, our longing to be reunited with something in the universe from which we now feel cut off, to be on the inside of some door which we have always seen from the outside is . . . the truest index of our real situation.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d153",
      "id": "a153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" The old ache and inconsolable longing will be gloriously healed as we are summoned and ushered into the bright and luminous joy. We shall be bathed in the beauty of God’s presence, and, as children know, a bath can be a hilarious thing. But for now, we travel the long, dusty road as a company of Chaucerian pilgrims on our way to Canterbury.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e771068"
    }
  }, [_c('span', [_vm._v("Our pilgrims’ status is demonstrated, among other things, by the ever-present restlessness in the human heart. We move from town to town, from job to job. Wanderers among us take to the road and sometimes live that way for months or years. But what are we seeking? We often describe it as looking for “home,” by which we don’t mean the place we were born. In "), _c('i', [_vm._v("Till We Have Faces")]), _vm._v(", Lewis’s character Psyche uses the analogy of homesickness to express a "), _c('i', [_vm._v("Sehnsucht ")]), _vm._v("that is painful: “It almost hurt me like a bird in a cage when the other birds of its kind are flying home . . . to find the place where all the beauty came from—my country, the place where I ought to have been born. The longing for home.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d154",
      "id": "a154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Lewis quoted the same simile in Chaucer’s “The Knight’s Tale,” in which the knight addresses the human journey: “All men know that the true good is Happiness, and all men seek it, but for the most part by wrong routes—like a drunk man who knows he has a house but can’t find his way home.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d155",
      "id": "a155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_69"
    }
  }, [_c('span', [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e778269"
    }
  }, [_c('span', [_vm._v("Once again, out of the experiences of his growing up, Lewis remembered a simple, childlike example of the homeward longing in which the capacity for joy grows: the end of a school term. He never forgot his anticipation of that blessed date, marked on the little penciled calendar on his desk. He later likened his feelings about it to that of the pilgrims as they approached their heavenly home (Beulah Land) in Bunyan’s "), _c('i', [_vm._v("Pilgrim’s Progress")]), _vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e781269"
    }
  }, [_c('span', [_vm._v("Bunyan tells us that when the Pilgrims came to the land of Beulah, “Christian with desire fell sick; Hopeful also had a fit or two of the same disease.” How well I know that sickness! It was no mere metaphor. . . . It was . . . a dizzying exaltation. . . . One had to think hard of common things lest reason should be overset. I believe it has served me ever since for my criterion of joy, and especially of the difference between joy and mere pleasure. Those who remember such Ends of Term are inexcusable if even, in later life, they allow mere pleasure to fob them off. One can tell at once when that razor-edged or needle-pointed quality is lacking: that shock, as if one were swallowing light itself."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d156",
      "id": "a156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_70"
    }
  }, [_c('span', [_vm._v("60")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e785670"
    }
  }, [_c('span', [_vm._v("Old or young, human beings generally feel a longing of this type—for something they find difficult to describe. It is difficult because the longing is intangible and ineffable. Thus, "), _c('i', [_vm._v("Sehnsucht ")]), _vm._v("remains in human nature, no matter how settled one may become; it is one of the things that mark our humanity. No other creature is so inherently dissatisfied as the human being.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e788370"
    }
  }, [_c('span', [_vm._v("From his childhood, Lewis connected joy with this deeply felt but indescribable nostalgia. The main object of his longing, however, was not some type of elusive “home.” Rather, surprisingly, it was a longing associated first with a season and then with a mythology. Lewis’s first taste of this “sweet desire” came before he was five years old, when reading Beatrix Potter’s story about Squirrel Nutkin who loses his tail. Why Squirrel Nutkin? Lewis answered,")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e790970"
    }
  }, [_c('span', [_vm._v("It troubled me with what I can only describe as the Idea of Autumn. . . . It sounds fantastic to say that one can be enamored of a season, but that is something like what happened and . . . the experience was one of intense desire. And one went back to the book, not to gratify the desire (how can one possess Autumn?) but to reawaken it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d157",
      "id": "a157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e793470"
    }
  }, [_c('span', [_vm._v("Then autumn was supplanted by something else—by a longing and a quest for joy that sustained Lewis through a convoluted path of youth and early adulthood shrouded with atheism, and which helped lead him eventually to faith in God. This heavenward longing was a passion for “Northernness,” for something distant and otherworldly—a passion awakened by the "), _c('i', [_vm._v("Twilight of the Gods ")]), _vm._v("(joy was an arrow shot from the north) and by the poetry of Longfellow (based on the Swedish "), _c('i', [_vm._v("Frithiof ’s Saga")]), _vm._v("). It was unexpected. The precocious young Lewis, nine or ten years old, was idly turning the pages of Longfellow’s "), _c('i', [_vm._v("King Olaf ")]), _vm._v("when he read for the first time the enchanting verse that began: “I heard a voice, that cried, ‘Balder the Beautiful / Is dead, is dead!’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d158",
      "id": "a158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_71"
    }
  }, [_c('span', [_vm._v("61")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e799471"
    }
  }, [_c('span', [_vm._v("The poem continues, enchanting evermore: “And through the misty air / Passed like the mournful cry / Of sunward sailing cranes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e800271"
    }
  }, [_c('span', [_vm._v("Of this poetry Lewis wrote:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e800971"
    }
  }, [_c('span', [_vm._v("I knew nothing about Balder; but instantly I was uplifted into huge regions of northern sky. I desired with almost sickening intensity something never to be described (except that it is cold, spacious, severe, pale and remote) and then . . . found myself at the very same moment already falling out of that desire and wishing I were back in it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d159",
      "id": "a159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e803471"
    }
  }, [_c('span', [_vm._v("From that point onward until his conversion, and perhaps even afterward, this Northern longing was a cold, intense fire that chance seemed to keep stoking in young Lewis. He pursued this “Northernness” mainly by reading books. But Lewis later pointed out that books were not the thing. They were mainly the channel:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e805371"
    }
  }, [_c('span', [_vm._v("The books or the music in which we thought the beauty was located will betray us if we trust to them; it was not in them, it only came through them, and what came through them was longing. These things—the beauty, the memory of our own past—are good images of what we really desire; but if they are mistaken for the thing itself they turn into dumb idols, breaking the hearts of their worshippers. For they are not the thing itself; they are only the scent of a flower we have not found, the echo of a tune we have not heard, news from a country we have never yet visited."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d160",
      "id": "a160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e808971"
    }
  }, [_c('span', [_vm._v("Not long after Lewis hit on this Northern longing, his mother died. She had become ill with cancer, recovered for a while, then became ill again and died. As he describes it, “With my mother’s death all settled happiness, all that was tranquil and reliable, disappeared from my life.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d161",
      "id": "a161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Lewis had prayed and prayed that God would heal his mother, but He did not. Whether this affected Lewis’s childhood faith (Lewis infers that it didn’t) one is left to wonder. Nevertheless, the next year, when he began the normal British boy’s progression through boarding schools, his faith in the God of Christianity began to decrease in inverse proportion to his increasing age and education. He comments that the impression he got during his early formal education was that “religion, in general, though utterly false, was a natural growth, a kind of endemic nonsense into which humanity tended to blunder.” In his early teens, the intellectual young Lewis decided he did not believe in the silly faith of his fathers. He “became an apostate, dropping [his] faith with no sense of loss but with the greatest relief.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d162",
      "id": "a162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_72"
    }
  }, [_c('span', [_vm._v("62")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e815572"
    }
  }, [_c('span', [_vm._v("Nevertheless, the Northern longing, a spiritual longing of a kind, continued to smolder. One day, when he was about fourteen years old, Lewis chanced to see the words “Siegfried and the twilight of the Gods” under an illustration from that volume.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e817172"
    }
  }, [_c('span', [_vm._v("Pure [Northernness] engulfed me. . . . There arose at once, almost like heartbreak, the memory of Joy itself. . . . The distance of the Twilight of the Gods and the distance of my own past Joy, both unattainable, flowed together into a single, unendurable sense of desire and loss. . . . And at once I knew that to “have it again” was the supreme and only important object of desire."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d163",
      "id": "a163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e819672"
    }
  }, [_c('span', [_vm._v("And have it again he did, soon thereafter, when he heard in a record shop one day “The Ride of the Valkyries” from Wagner’s "), _c('i', [_vm._v("Ring of the Nibelungen ")]), _vm._v("cycle. “To a boy crazed with ‘Northernness,’ whose highest musical experience had been [Gilbert and] Sullivan, the Ride came like a thunderbolt.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d164",
      "id": "a164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e822272"
    }
  }, [_c('span', [_vm._v("Northernness became like a religion for Lewis. It awoke in him a capacity, not yet experienced in the context of Christianity, for true worship—not that he really believed in the Norse gods whose music and literature he now devoured. He didn’t at all believe them to be real, but he felt for them “some kind of quite disinterested self-abandonment to an object which securely claimed this by simply being the object it was.” Looking back on this period later, Lewis wondered if God hadn’t kept that capacity for worship alive for His own purposes. “Sometimes,” Lewis wrote in his autobiography, “I can almost think that I was sent back to the false gods there to acquire some capacity for worship against that day when the true God should recall me to himself.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d165",
      "id": "a165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_73"
    }
  }, [_c('span', [_vm._v("63")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e826773"
    }
  }, [_c('span', [_vm._v("Over the next ten years Lewis became an expert in Norse literature and mythology. He read everything there was to read on the subject in English while he was still in secondary school. When he reached Oxford, he studied Old Norse and read what hadn’t yet been translated. But Lewis noticed that his expertise did not heighten that joy he had felt, “Northernness.” It did rather the opposite. “From these books again and again,” he wrote, “I received the stab of Joy. I did not yet notice that it was, very gradually, becoming rarer. I did not yet reflect on the difference between it and . . . merely intellectual satisfaction.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d166",
      "id": "a166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e826173"
    }
  }, [_c('span', [_vm._v("Joy, however, was still Lewis’s quest. Patches of remembered boyhood could be stirred and awakened by some sudden smell or sound or image. Exquisite Proustian or Wordsworthian moments sometimes carried for Lewis stabs of “an almost unbearable pleasure.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d167",
      "id": "a167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Such joys could be “so sharp that they might sting.” These momentary tastes of joy were like “seconds of gold scattered in months of dross.” Sweet pangs of joy “passed along the spine with delicious, yet harrowing thrills: took away the appetite: made sleep impossible.” But that distinguishing sleeplessness—the “sting,” those “razor-edged,” “needle-pointed” qualities—became more and more elusive. “Northernness,” philosophy (which Lewis loved), wine, women, and song were not producing them. Something was missing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e834773"
    }
  }, [_c('span', [_vm._v("At Oxford, Lewis, who had been an avowed atheist for years, met for the first time Christians whom he liked and whose intellects he respected. To this vexation was added a similar one when, as Lewis puts it, “all the books were beginning to turn against me.” He began to notice that many of the authors he most liked were Christians. Previously he had been rationalizing away that fact by saying of Chesterton, for instance, that “he had more sense than all the other moderns put together; bating, of course, his Christianity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d168",
      "id": "a168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" But now these defenses were beginning to show cracks.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_74"
    }
  }, [_c('span', [_vm._v("64")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e838974"
    }
  }, [_c('span', [_vm._v("Soon afterward Lewis read Chesterton’s "), _c('i', [_vm._v("The Everlasting Man")]), _vm._v(". “Somehow I contrived,” he says, “not to be too badly shaken.” But someone was closing in. God had apparently determined to reveal Himself to Lewis, this hardheaded, atheistic philosopher. Resist as Lewis might, God’s approach was inexorable. “You must picture me,” Lewis wrote, “alone in that room in Magdalen, night after night, feeling, whenever my mind lifted even for a second from my work, the steady, unrelenting approach of Him whom I so earnestly desired not to meet.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d169",
      "id": "a169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e843074"
    }
  }, [_c('span', [_vm._v("Finally, in 1929, Lewis gave in—not yet to Christianity, but to theism. He “admitted that God was God, and knelt and prayed: perhaps, that night, the most dejected and reluctant convert in all England.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d170",
      "id": "a170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" He began to attend church and to read the Gospels. He was surprised to find that they did not have the flavor of myth. They read like histories. Lewis had acknowledged God; now God was after him to acknowledge His Son. The subject was on Lewis’s mind constantly. In a now famous passage of "), _c('i', [_vm._v("Surprised by Joy")]), _vm._v(", Lewis related his final step into real joy: “I know very well when, but hardly how, the final step was taken. I was driven to Whipsnade one sunny morning. When we set out I did not believe that Jesus Christ is the Son of God, and when we reached the zoo I did.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d171",
      "id": "a171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e848774"
    }
  }, [_c('span', [_vm._v("So C. S. Lewis was drawn into the kingdom of God by joy—by a taste of this blessed fruit and divine gift. Joy was the divine carrot that persuaded such a self-proclaimed donkey as Lewis to plod down the road toward Jerusalem. It was the soft, disturbing kiss of God that unmade all of Lewis’s world. Joy compelled Lewis toward the resurrection laughter of Easter, yet it was a path that had to pass through Good Friday. As Lewis grew in his faith, there would be no detour around the tears and tribulations of life—of being stomped, pressed down, and crushed like grapes—so that the sweet wine of intoxicating laughter could be poured out on dry, thirsty souls.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_75"
    }
  }, [_c('span', [_vm._v("65")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e852575"
    }
  }, [_c('span', [_vm._v("After his conversion, Lewis went on to build a successful academic career, publish excellent work in his field, and become a celebrated apologist for Christianity. He had passed contentedly into late middle age, when, once more, he was surprised—ambushed—by joy. Professor Lewis fell in love with and married an American woman named Joy Davidman. The coincidence of Lewis’s wife’s name was compounded by the fact that his autobiography, "), _c('i', [_vm._v("Surprised by Joy")]), _vm._v(", was published at the time she was becoming an integral and happy part of his life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e855875"
    }
  }, [_c('span', [_vm._v("A few years later Joy became ill. At first, Lewis wrote of the experience that “you would not believe how many joys have been experienced amid these troubles. And what wonder? For has He not promised to comfort those who mourn? . . . I am in much trouble. Nevertheless let us lift up our hearts: for Christ is risen.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d172",
      "id": "a172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The vale of tears is also a well of living waters. “If we are happy, then we remember that the crown is not promised without the Cross and tremble.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d173",
      "id": "a173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e859175"
    }
  }, [_c('span', [_vm._v("However, after a joyful but short remission in her cancer, Lewis’s Joy, his beloved wife, died. His faith was seared and scarred, and, for a while, it seemed a hopeless and perhaps even pointless struggle to retain it. Who cared anymore? Some of the depth of Lewis’s sorrow can be read in a poem he wrote about Joy’s death, entitled, “Joys That Sting”: "), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e861075"
    }
  }, [_c('span', [_c('i', [_vm._v("Oh do not die, says Donne, for I shall hate ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e861375"
    }
  }, [_c('span', [_c('i', [_vm._v("All women so. How false the sentence rings.")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e861875"
    }
  }, [_c('span', [_c('i', [_vm._v("Women? But in a life made desolate ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e862175"
    }
  }, [_c('span', [_c('i', [_vm._v("It is the joys once shared that have the stings.")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e862775"
    }
  }, [_c('span', [_c('i', [_vm._v("To take the old walks alone, or not at all, ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e863075"
    }
  }, [_c('span', [_c('i', [_vm._v("To order one pint where I ordered two, ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e863375"
    }
  }, [_c('span', [_c('i', [_vm._v("To think of, and then not to make, the small ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e863675"
    }
  }, [_c('span', [_c('i', [_vm._v("Time-honoured joke (senseless to all but you); ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e864075"
    }
  }, [_c('span', [_c('i', [_vm._v("To laugh (oh, one’ ll laugh), to talk upon ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e864375"
    }
  }, [_c('span', [_c('i', [_vm._v("Themes that we talked upon when you were there, ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e864675"
    }
  }, [_c('span', [_c('i', [_vm._v("To make some poor pretence of going on, ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e864975"
    }
  }, [_c('span', [_c('i', [_vm._v("Be kind to one’s old friends, and seem to care, ")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_76"
    }
  }, [_c('span', [_vm._v("66")])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e865776"
    }
  }, [_c('span', [_c('i', [_vm._v("While no one (O God) through the years will say ")])])]), _vm._v(" "), _c('p', {
    staticClass: "literal",
    attrs: {
      "id": "d7e866076"
    }
  }, [_c('span', [_c('i', [_vm._v("The simplest, common word in just your way."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d174",
      "id": "a174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e866976"
    }
  }, [_c('span', [_vm._v("Joy’s early death by cancer initiated a piercing personal struggle for Lewis. He had literally and metaphorically lost his Joy. The pain of this earthly separation was recorded in painfully raw candor in "), _c('i', [_vm._v("A Grief Observed")]), _vm._v(". Now Lewis not only knew about pain but also had come to know it intimately. And in his bereavement, he shook his puny little fist at the brass heavens.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e869676"
    }
  }, [_c('span', [_vm._v("“It was too perfect to last,” so I am tempted to say of our marriage. But it can be meant in two ways. It may be grimly pessimistic—as if God no sooner saw two of His creatures happy than He stopped it (“None of that here!”). As if He were like the Hostess at the Sherry party who separates two guests the moment they show signs of having got into a real conversation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d175",
      "id": "a175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e872376"
    }
  }, [_c('span', [_vm._v("In his grief, Lewis longed for his wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e873076"
    }
  }, [_c('span', [_vm._v("[She is what] I am mourning for, homesick for, famished for. You tell me “she goes on.” But my heart and body are crying out, come back, come back. . . . But I know this is impossible. I know that the thing I want is exactly the thing I can never get. The old life, the jokes, the drinks, the arguments, the lovemaking, the tiny, heartbreaking commonplace."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d176",
      "id": "a176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e875676"
    }
  }, [_c('span', [_vm._v("Nights became desolate, sleepless trails that descended into lonely valleys—dark places of sorrow and despair. Then, to this man in total darkness, who imagines he is in a cellar or dungeon, comes a small, faint sound.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e877276"
    }
  }, [_c('span', [_vm._v("He thinks it might be a sound from far off—waves or windblown trees or cattle half a mile away. And if so, it proves he’s not in a cellar, but free, in the open air. Or it may be a much smaller sound close at hand—a chuckle of laughter. And if so, there is a friend just beside him in the dark. Either way, a good, good sound."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d177",
      "id": "a177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_77"
    }
  }, [_c('span', [_vm._v("67")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e879977"
    }
  }, [_c('span', [_vm._v("Hope—the thing with feathers that perches in the soul—lived in a cage of ache and agony in anticipation of joy. It took flight, finally, in one of Lewis’s remembrances:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e881277"
    }
  }, [_c('span', [_vm._v("Once very near the end I said, “If you can—if it is allowed—come to me when I too am on my death bed.” “Allowed,” she said. “Heaven would have a job to hold me; and as for Hell, I’d break it into bits.” She knew she was speaking a kind of mythological language, with even an element of comedy in it. There was a twinkle as well as a tear in her eye. But there was no myth and no joke about the will, deeper than any feeling, that flashed through her."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d178",
      "id": "a178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e884277"
    }
  }, [_c('span', [_vm._v("Remembering this exchange was the beginning of Lewis’s recovery. The memory scourged his soul but also purified it. It would do little good to turn to his wife’s memory with morbid sadness and increasing anger; the facts were hard as nails. The most difficult leap for Lewis came in his weakness of will: “I will turn to her as often as possible in gladness. I will even salute her with a laugh. The less I mourn her the nearer I seem to her.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d179",
      "id": "a179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e887077"
    }
  }, [_c('span', [_vm._v("Just as suffering was as certain as night, joy was as sure as the coming morning. In the crucible of watching his wife die, Lewis remembered the incredible happiness and “gaiety we sometimes had together after all hope was gone.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d180",
      "id": "a180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" It was a hint of dawn. The moment became a savoring of what the Germans call "), _c('i', [_vm._v("Das Erhabene")]), _vm._v(", the instant of being moved and feeling pain in a positive way, of allowing the laughter and the tear to cohabit the tomb of the eye. Death, Lewis remembered now, was by no means a permanent separation. There was heaven—joy would be there. Both “Joys.” No farewells are final. In a letter to Father John, an Italian priest in Verona with whom he carried on a correspondence in Latin, Lewis expressed the view that comforted him in his wife’s death: “Now indeed mountains and seas divide us, nor do I know what your appearance is in the body. God grant, on that day hereafter, day of the resurrection of the body, yes, and of all things made, beyond our telling, new—God grant us, on that Day, to meet.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d181",
      "id": "a181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_78"
    }
  }, [_c('span', [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e894178"
    }
  }, [_c('span', [_vm._v("Later, in a letter to Dom Bede Griffiths about friendship (November 1959), Lewis expressed his understanding of the meaning and enduring joy of his short marriage:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e895478"
    }
  }, [_c('span', [_vm._v("Are not all lifelong friendships born at the moment when at last you meet another human being who has some inkling (but faint and uncertain even in the best) of that something which you were born desiring, and which, beneath the flux of other desires and in all the momentary silences between the louder passions, night and day, year by year, from childhood to old age, you are looking for, watching for, listening for? You have never had it. All the things that have ever deeply possessed your soul have been but hints of it—tantalizing glimpses, promises never quite fulfilled, echoes that died away just as they caught your ear. But if it should really become manifest—if there ever came an echo that did not die away but swelled into the sound itself—you would know it. Beyond all possibility of doubt you would say “Here at last is the thing I was made for.” We cannot tell each other about it. It is the secret signature of each soul, the incommunicable and unappeasable want, the thing we desired before we met our wives or made our friends or chose our work, and which we shall still desire on our deathbeds, when the mind no longer knows wife or friend or work. While we are, this is. If we lose this, we lose all."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d182",
      "id": "a182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e902078"
    }
  }, [_c('span', [_vm._v("When his dear friend Charles Williams died suddenly, Lewis observed that it wasn’t his idea of Charles Williams that changed as much as his idea of death. Death became to him the final barrier or separation before the final reunion—the grand, glad reunion. Death could only be feared, ignored, or desired, and Lewis opted for the last. It would be like stripping off the hair shirt of this life or getting out of a dungeon. To Mary, an American woman, he compared their sickly, bedridden lives as being drowsy seeds awaiting the Gardener’s good time to come up as real flowers. “It will be fun when we at last meet” in a better place."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d183",
      "id": "a183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_79"
    }
  }, [_c('span', [_vm._v("69")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e906279"
    }
  }, [_c('span', [_vm._v("Throughout his life, stabs of joy were to C. S. Lewis like faint whispers from beyond the world, a meek and plaintive call from “the horns of elfland” for lost, aimless, weary pilgrims to “come home, come home.” For Lewis, this special happiness we seek can be found only in God. Or, as Augustine professed, “Our hearts are restless until they rest in Thee.” What our hearts seek and hunger after is the overwhelming joy of homecoming and reunion with a Beloved.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e908879"
    }
  }, [_c('span', [_vm._v("The terror, however, is that we may never find our way to this heavenly home we are looking for. We may be utterly and hopelessly lost, stumbling like Dante into a dark wood. Or we may even choose to be deliberately prodigal. We may plod and trod what Keats called “the journey homeward to habitual self.” Moving downward toward ourselves, we see we suffer from the law of spiritual gravitation—of falling away from God. Yet an incredible hope sneaks into our consciousness that we will be found, called in, reeled up, received, welcomed. Lewis certainly was that—not just passively found, but actively hunted down by God. Lewis had searched and searched for joy. And when God found him, the object of his desire, grand as it was, paled in comparison.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a6db3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c15_r1.vue
// module id = 99
// module chunks = 0